import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import customAnimation from "assets/lottie/general/anim_04.json";
import explainerAnimation from "assets/lottie/general/anim_05.json";
import artisticAnimation from "assets/lottie/general/anim_06.json";
import bgDesktop from "assets/images/bgs/orange.svg";
import bgMobile from "assets/images/bgs/orange_mobile.svg";

// Reusable FeatureCard Component
const FeatureCard = ({ animationData, title, description, flip }) => {
  
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet', // Ensures the animation fits inside the container without cropping
      },
    };
  
    return (
      <div
        className="p-6 rounded-2xl shadow-lg text-white bg-gradient-to-t from-indigo-500 to-purple-600"
      >
        <div className="h-[200px] w-[200px] mx-auto mb-4">
          <Lottie
            options={defaultOptions}
            style={{
              width: '100%',
              height: '100%',
              cursor: 'default',
              transform: flip ? 'scaleX(-1)' : 'scaleX(1)', // Flip horizontally if flip is true
            }}
            isClickToPauseDisabled={true} // Disables pause on click
          />
        </div>
        <h3 className="text-2xl font-bold mb-4">{title}</h3>
        <p>{description}</p>
      </div>
    );
};
  

// Features Component
const Features = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center mx-auto p-8 bg-cover bg-center"
      style={{
        backgroundImage: `url(${isMobile ? bgMobile : bgDesktop})`,
      }}
    >
      <FeatureCard
        animationData={customAnimation}
        title="Custom Animations"
        description="Tailored animations that perfectly fit your brand’s story."
        flip={true}
      />
      <FeatureCard
        animationData={explainerAnimation}
        title="Explainer Videos"
        description="Engage your audience with compelling explainer videos."
      />
      <FeatureCard
        animationData={artisticAnimation}
        title="Artistic Visuals"
        description="Creative and vibrant visuals designed to captivate and inspire."
    />
    </div>
  );
};

export default Features;
